import { useEffect, useMemo, useState } from 'react';
import { IntelligentPhotoCaptureMandatoryPhotosConstants } from '../constants';
import { getMissingContentTypes, isIterationBlockingMandatoryValidation } from '../utilities';
export const useMandatoryContentTypesValidation = ({ attachmentIterationInfo, countryCode, estimatorConfiguration, estimatorInstanceCount, photoCaptureAttachmentInfo, uploadStatusShowProgress }) => {
    const [missingContentTypes, setMissingContentTypes] = useState([]);
    const shouldValidateMandatoryContentTypes = useMemo(() => {
        if (uploadStatusShowProgress) {
            return false;
        }
        return !attachmentIterationInfo.some((iteration) => isIterationBlockingMandatoryValidation(iteration));
    }, [attachmentIterationInfo, uploadStatusShowProgress]);
    const attachmentInfo = useMemo(() => {
        if (!shouldValidateMandatoryContentTypes) {
            return null;
        }
        return photoCaptureAttachmentInfo || [];
    }, [photoCaptureAttachmentInfo, shouldValidateMandatoryContentTypes]);
    useEffect(() => {
        if ((estimatorInstanceCount || 0) > IntelligentPhotoCaptureMandatoryPhotosConstants.ESTIMATOR_INSTANCE_COUNT ||
            !shouldValidateMandatoryContentTypes ||
            !attachmentInfo) {
            setMissingContentTypes([]);
            return;
        }
        const missingContentTypesResult = getMissingContentTypes(attachmentInfo, countryCode, estimatorConfiguration);
        setMissingContentTypes(missingContentTypesResult);
    }, [
        attachmentInfo,
        countryCode,
        estimatorConfiguration,
        estimatorInstanceCount,
        shouldValidateMandatoryContentTypes
    ]);
    return missingContentTypes;
};
//# sourceMappingURL=useMandatoryContentTypesValidation.js.map